/* prebid.js v8.52.0-pre
Updated: 2024-07-05
Modules: All available modules for this version. */

if (!window.pbjs || !window.pbjs.libLoaded) {
 (function(){